module.exports = __webpack_public_path__ + "components/outside-promo-page/static/runners-b8bff14fda2d5fe8c2d8e799888b4dc4.webp";